export const splitBaseGroup = (groups: any[]) => {
  const count = groups.filter((group) => group.id === 'base').length;
  if (count > 1) {
    return groups;
  }

  const baseGroup = groups.find((group) => group.id === 'base');
  if (!baseGroup) return groups;

  const { items = [] } = baseGroup;
  const newItems = [];

  for (let item of items) {
    const { name } = item;

    const group = groups.find((group) => group.name.replace(/ /g, '') === name);

    if (!group) {
      newItems.push(item);
      continue;
    }

    group.items.unshift(item);
  }

  baseGroup.items = newItems;

  return groups;
};
